import { useState } from "react";
import { MapContainer, LayersControl, TileLayer } from "react-leaflet";
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import Position from "./Position";
import Markers from "./Markers";

const MAP_WIDTH = 15084;
const MAP_HEIGHT = 12595;
const CENTER = [MAP_HEIGHT / 2, MAP_WIDTH / 2];
const ZOOM_LEVEL = 5;

const simpleCRS = L.extend({}, L.CRS.Simple, {
  transformation: new L.Transformation(1 / 64, 0, 1 / 64, 0),
});

const LeafletMap = ({ layers, activeLayer, markers }) => {
  const [map, setMap] = useState(null);

  return (
    <>
      {map && <Position map={map} center={CENTER} />}
      <MapContainer
        center={CENTER}
        zoom={ZOOM_LEVEL}
        minZoom={ZOOM_LEVEL}
        maxZoom={ZOOM_LEVEL}
        crs={simpleCRS}
        zoomControl={false}
        attributionControl={false}
        dragging={false}
        doubleClickZoom={false}
        scrollWheelZoom={false}
        boxZoom={false}
        touchZoom={false}
        keyboard={false}
        tap={false}
        whenCreated={setMap}
        className="map"
      >
        <LayersControl>
          {layers.map((layer) => {
            return (
              <LayersControl.BaseLayer
                key={layer.name}
                name={layer.name}
                checked={layer.name === activeLayer.name}
              >
                <TileLayer
                  url={`${process.env.PUBLIC_URL}/tiles/${layer.name}/{z}/{x}/{y}.png`}
                />
              </LayersControl.BaseLayer>
            );
          })}
        </LayersControl>
        <Markers markers={markers} activeLayer={activeLayer} />
      </MapContainer>
    </>
  );
};

export default LeafletMap;
